export const aleksanderJachowski = {
    'firstName': 'Aleksander',
    'lastName': 'Jachowski',
    'profession': 'Psycholog, psychoterapeuta systemowy',
    'avatar': 'aleksander-jachowski.webp',
    'slug': 'psycholog-psychoterapeuta-systemowy-aleksander-jachowski',
    'locations': ['torun'],
    'services': [
        ['psychoterapy', 'children'],
        ['psychoterapy', 'adult'],
        ['psychoterapy', 'parents'],
        ['psychoterapy', 'family'],
        ['group', 'developmentGroup'],
    ]
}